module.exports = __webpack_public_path__ + "static/img/his-centralized-patient-record.1319359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-centralized-patient-record.png
// module id = /em8
// module chunks = 2